import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { fuseAnimations } from "@fuse/animations";
import { fromEvent, Subject, Subscription } from "rxjs";
import {
    debounceTime,
    distinctUntilChanged,
    finalize,
    map,
    takeUntil,
} from "rxjs/operators";

import { MatTableDataSource } from "@angular/material/table";

import { MatSelectChange } from "@angular/material/select";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { SucursalPersonaDTO } from "app/main/apps/shared/interfaces/sucursal-persona.interface";
import { CatalogoService } from "app/main/apps/shared/services/rest/catalogo.service";
import { ServicioDTO } from "app/main/apps/shared/interfaces/servicio.interface";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { config as CONFIG } from "app/app.config";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { OnDestroy } from "@angular/core";

@Component({
    selector: "app-tabla-servicios",
    templateUrl: "./tabla-servicios.component.html",
    styleUrls: ["./tabla-servicios.component.scss"],
    animations: fuseAnimations,
})
export class TablaServiciosComponent implements OnInit, OnDestroy {
    dataSource: MatTableDataSource<ServicioDTO>;
    displayedColumns = [
        "descripcion",
        "sucursal",
        "valorUnitarioUF",
        "agregar",
    ];
    @Input() sucursales: SucursalPersonaDTO[];

    @Output() agregarServicio: EventEmitter<any> = new EventEmitter();
    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;

    @ViewChild("filter", { static: true })
    filter: ElementRef;

    // Private
    private _unsubscribeAll: Subject<any>;
    subscripciones: Subscription;

    constructor(
        private _catalogoSrvc: CatalogoService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _notificacionSrvc: NotificacionesService,
        private _menuUsuarioSrvc: MenuUsuarioService
    ) {
        this._unsubscribeAll = new Subject();
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {
        this.subscripciones.add(
            this._catalogoSrvc.onServiciosChanged.subscribe((servicios) => {
                //console.log(servicios);
                //selecciona la primera sucursal automaticamente y faltaria hacer que se calcule el valor del serivcio segun el factor de la sucursal
                /*servicios.map((servicio) => {
                servicio.sucursalSeleccionada = this.sucursales[0].id;
                return servicio;
            });*/

                this.dataSource = new MatTableDataSource(servicios);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            })
        );

        this.subscripciones.add(
            fromEvent(this.filter.nativeElement, "keyup")
                .pipe(
                    takeUntil(this._unsubscribeAll),
                    debounceTime(150),
                    distinctUntilChanged()
                )
                .subscribe(() => {
                    if (!this.dataSource) {
                        return;
                    }

                    this.dataSource.filter = this.filter.nativeElement.value;
                })
        );
    }

    agregar(servicio) {
        //console.log(servicio);
        this.agregarServicio.emit(servicio);
    }

    calcularPecio(event: MatSelectChange, servicio: ServicioDTO) {
        const puedeCotizar = this._menuUsuarioSrvc.puedeRealizarAccion(
            servicio.sucursalSeleccionada,
            "puedeCotizar"
        );
        if (puedeCotizar) {
            servicio.cargandoPrecio = true;
            this._fuseProgressBarService.show();
            //console.log(event.value);
            //console.log(servicio);
            const sucursal = this.getSucursal(event.value);
            //console.log(sucursal);
            this.subscripciones.add(
                this._catalogoSrvc
                    .fetchPrecioServicio(servicio.id, sucursal.comuna.id)
                    .pipe(
                        finalize(() => {
                            this._fuseProgressBarService.hide();
                            servicio.cargandoPrecio = false;
                        })
                    )
                    .subscribe((resp) => (servicio.precio = resp))
            );
        } else {
            this._notificacionSrvc.mostrarNotificacion(
                `No esta autorizado para cotizar en esta sucursal, favor contacte a su representante`,
                "error"
            );
        }
    }

    getSucursal(idSucursal: number): SucursalPersonaDTO {
        return this.sucursales.filter(
            (sucursal) => sucursal.id === idSucursal
        )[0];
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
